import { SHARED_CHAT_TYPES } from '@features/components/Chat/constants';
import { MdOutlineWifiTethering } from 'react-icons/md';
import { StreamChannelType } from '@/api/apis/chat';

export const SharedChannelBadge = ({ channelType }: { channelType: StreamChannelType }) => {
  return SHARED_CHAT_TYPES.includes(channelType) && <MdOutlineWifiTethering size={14} className="text-maroon-20" />;
};
